import FlowBpmUiHost from "../../pages/flowBpm/FlowBpmUiHost";

const route = {
  key: "flowBpmUi",
  path: "/flow-bpm-ui",
  component: FlowBpmUiHost,
  permission: "flow-bpm.task.read",
  private: true,
  layout: "main",
  icon: "faWindowMaximize",
  group: "bpm",
  order: 19,
};

export default route;
